LoginModalDirective.$inject = ['auth', 'api', '$rootScope', 'notify', '_password'];
function LoginModalDirective(auth, api, $rootScope, notify, _password) {
    return {
        template: require('./views/login-modal.html'),
        link: function (scope, element, attrs) {
            scope.active = false;
            scope.error = null;
            scope.currentUser = null;
            scope.logging = false;
            scope.register = false;
            scope.data = {
                tokenExtend: 0
            };
            scope.$watch(function getAuthToken() {
                return auth.getToken();
            }, function (token) {
                if (!token) {
                    scope.active = true;
                    scope.username = null;
                    scope.password = null;
                    scope.currentUser = null;
                }
                else {
                    scope.active = false;
                    api.get('/profile').then(function (response) {
                        $rootScope.currentUser = response;
                    });
                }
            });
            scope.login = function () {
                scope.error = null;
                scope.logging = true;
                api.post('/login', { username: scope.data.username, password: scope.data.password, tokenExtend: scope.data.tokenExtend })
                    .then(function (response) {
                    auth.setToken(response.token);
                    auth.resolveIdentity();
                    scope.active = false;
                    scope.logging = false;
                    scope.data.username = null;
                    scope.data.password = null;
                }, function (error) {
                    scope.logging = false;
                    scope.error = error;
                    console.log(error.data);
                });
            };
            scope.forgotPassword = function () {
                _password.forgotPasswordModal().then(function (response) {
                    notify.success(response);
                }, function (error) {
                    notify.error(error.data);
                    console.log(error);
                });
            };
            scope.handleEnter = function ($event) {
                if ($event.keyCode === 13) {
                    scope.login();
                }
            };
        }
    };
}
angular.module('rinca.core.main.login', [])
    .directive('loginModal', LoginModalDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/login-modal.ts
// module id = 288
// module chunks = 0